import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import shiftService from '../services/shift.service';


export const fetchShiftList = createAsyncThunk(
  'shift/fetchShiftList',
  async ({ page, pagesize }, thunkAPI) => {
    try {
      const response = await shiftService.getShiftList(page, pagesize);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);


export const createShift = createAsyncThunk(
  'shift/createShift',
  async (payload, thunkAPI) => {
    console.log(payload)
    try {
      const response = await shiftService.addShift(payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateShift = createAsyncThunk(
  'shift/updateShift',
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await shiftService.editShift(id, data);
      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteShift = createAsyncThunk(
  'shift/deleteShift',
  async (id, thunkAPI) => {
    try {
      await shiftService.deleteShift(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const initialState = {
  data: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  error: null,
  loading: false,
  hasMore: true,
};

const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {
    resetShiftData: (state) => {
      state.data = []; // This will clear the list
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchShiftList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftList.fulfilled, (state, action) => {
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchShiftList.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(createShift.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createShift.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createShift.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(updateShift.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateShift.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(updateShift.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(deleteShift.pending, state => {
        state.loading = true;
      })
      .addCase(deleteShift.fulfilled, (state, action) => {
        state.data = state.data.filter(group => group.id !== action?.meta?.arg); // Remove the deleted group from state
        state.totalRecord = state.totalRecord - 1;
        state.loading = false;
      })
      .addCase(deleteShift.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});


export const { resetShiftData } = shiftSlice.actions;
export default shiftSlice.reducer;


